import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import space_ft from '../assets/skybox/space_ft.png'
import space_bk from '../assets/skybox/space_bk.png'
import space_up from '../assets/skybox/space_up.png'
import space_dn from '../assets/skybox/space_dn.png'
import space_rt from '../assets/skybox/space_rt.png'
import space_lf from '../assets/skybox/space_lf.png'

import crash1 from '../assets/Crash/1.webp';
import crash2 from '../assets/Crash/2.webp';
import crash3 from '../assets/Crash/3.webp';
import crash4 from '../assets/Crash/4.webp';
import crash5 from '../assets/Crash/5.webp';
import crash6 from '../assets/Crash/6.webp';


export {crash1, crash2, crash3, crash4, crash5, crash6};

import earthTexture from '../assets/2k_earth_daymap.jpg'

import { randomOrbit, randomOrbitTrack } from './orbitFunctions.js'

//Setting THREE Js up
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );

const renderer = new THREE.WebGLRenderer({
  canvas: document.querySelector('#earth-space-bg'),
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize( window.innerWidth, window.innerHeight );

camera.position.z = 110;
camera.updateProjectionMatrix();

//Controlls
const controls = new OrbitControls(camera, renderer.domElement);
controls.enableZoom = false;
controls.autoRotate = true;

//Ligthings
const light = new THREE.PointLight( 0xfefff0, 2, 300 );
light.position.set( 50, 50, 25 );
scene.add( light );
const ambientlight = new THREE.HemisphereLight( 0xfefff0, 0x080820, .4 );
scene.add( ambientlight );


//Background
const loader = new THREE.CubeTextureLoader();
const texture = loader.load([
    space_ft,
    space_bk,
    space_up,
    space_dn,
    space_rt,
    space_lf
]);
scene.background = texture;

//Earth
const earthGeo = new THREE.SphereGeometry(12.742, 30, 30);
const loaderEarth = new THREE.TextureLoader();
const earthMat = new THREE.MeshStandardMaterial({
    map: loaderEarth.load(earthTexture),
});
const earth = new THREE.Mesh(earthGeo, earthMat);
scene.add(earth);

//Adding Space Junk
function addSpaceJunk(orbitMin, orbitMax) {
  const geomatry = new THREE.SphereGeometry(.15, 3, 3);
  const material = new THREE.MeshStandardMaterial({color: 0xffffff})
  const junk = new THREE.Mesh(geomatry, material)

  let orbit = randomOrbit(orbitMin, orbitMax);
  const [x, y, z] = orbit;
  junk.position.set(x,y,z);
  scene.add(junk);
}

function addSpaceJunkTrack(orbitMin, orbitMax, width) {
  const geomatry = new THREE.SphereGeometry(.2, 3, 3);
  const material = new THREE.MeshStandardMaterial({color: 0xffffff})
  const junk = new THREE.Mesh(geomatry, material)

  let orbit = randomOrbitTrack(orbitMin, orbitMax, width);
  const [x, y, z] = orbit;
  junk.position.set(x,y,z);
  scene.add(junk);
}

//LEO
for (let i = 0; i < (20710/2.5); i++) {
  addSpaceJunk(.18, 2);
}

//GEO
for (let i = 0; i < (900/2.5); i++) {
  addSpaceJunkTrack(32, 35, 2);
}

//EGO
for (let i = 0; i < (2678/2.5); i++) {
  addSpaceJunk(38, 46);
}

//GTO
for (let i = 0; i < (1256/2.5); i++) {
  addSpaceJunk(38, 46);
}

//NSO
for (let i = 0; i < (403/2.5); i++) {
  addSpaceJunk(18.1, 24.3);
}

//MEO
for (let i = 0; i < (658/2.5); i++) {
  addSpaceJunk(2, 35);
}

//GTO LMO MGO
for (let i = 0; i < (7098/2.5); i++) {
  addSpaceJunk(2, 31);
}

//HEO
for (let i = 0; i < (1177/2.5); i++) {
  addSpaceJunk(35, 80);
}


//Updating animation
function animate() {
	requestAnimationFrame( animate );
  controls.update();
	renderer.render( scene, camera );
}

animate();